import "./App.css";
import "react-calendar-timeline/lib/Timeline.css";
import Calender from "./Calender";
import { Box, Container, Grid } from "@mui/material";
import GlobalChatBox from '../../../components/GlobalChatBox/GlobalChatBox';
import { useState, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

const SectionWrapper = {
  backgroundColor: "#193042",
  minHeight: "100vh",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  "& .CalenderWrapper": {
    "& .MainHeading": {
      textAlign: "center",
      color: "#fff",
      fontSize: "42px",
      marginBottom: "20px",
    },
    "& .SubHeaderBtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 0 10px",
      "& .CheckboxWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        "& input": {
          width: "17px",
          height: "17px",
        },
        "& label": {
          color: "#ffffff",
        },
      },
      "& .ButtonWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "15px",
        "& button": {
          backgroundColor: "#49baeb",
          color: "#fff",
          padding: "8px 24px 7px",
          borderRadius: "50px",
        },
      },
    },
    "& .react-calendar-timeline": {
      "& .rct-header-root.sticky": {
        backgroundColor: "#4897D8",
      },
      "& .rct-scroll": {
        overflowX: "hidden",
      },
      "& .rct-horizontal-lines": {
        "& .rct-hl-even": {
          backgroundColor: "#003258",
        },
      },
    },
  },
};

function App(props) {
  // State to track if the calendar is loading
  const [isLoading, setIsLoading] = useState(true);
  const { azureImportLevelFive: showChatBoxFlag = true } = useFlags();

  useEffect(() => {
    // Set loading to false after calendar is mounted
    setIsLoading(false);
  }, []);

  return (
    <div className="py-4 relative">
      <Calender {...props} />
      {!isLoading && showChatBoxFlag && <GlobalChatBox isGlobal={true} />}
    </div>
    
    // <Box component={"section"} sx={SectionWrapper} className="!bg-white dark:!bg-[#111928]">
      // <Container maxWidth="">
        // <Box sx={{ flexGrow: 1 }}>
        //   <Grid
        //     container
        //     spacing={{ xs: 2, md: 2 }}
        //     sx={{ mt: "0 !important", justifyContent: "center" }}
        //   >
        //     <Grid item xs={12} md={12}>
        //       <Box className="CalenderWrapper">
        //         <Calender {...props} />
        //       </Box>
        //     </Grid>
        //   </Grid>
        // </Box>
      // </Container>
    // </Box>
  );
}

export default App;
